import React, {useEffect, useContext} from "react";
import { AppContext } from "../../components/States/AppContext";


//styles
import { SettingAlertMessage } from "./SettingAlert.elements";



export const SettingAlertAudioOff = () => {
  return (
    <>
      <SettingAlertMessage>
        <div>Audio off at <br></br> device</div>
      </SettingAlertMessage>
    </>
  );
};

export const SettingAlertSync = () => {
  return (
    <>
      <SettingAlertMessage>
        <div>Settings sync'd</div>
      </SettingAlertMessage>
    </>
  );
};